"use client"

import { useTranslations } from "next-intl"

import { FilterPanel } from "@/components/marketplace/listing/filter-panel"
import type { FacetOption } from "@/components/marketplace/listing/types"
import { Button, Sheet } from "@/components/ui"
import type { SearchFacet, SearchQuery } from "@/lib/types/search"

interface FilterSheetProps {
  open: boolean
  onClose: (open: boolean) => void
  query: SearchQuery
  categoryOptions?: FacetOption[]
  facets?: SearchFacet[]
  filterCount: number
  resultCount?: number
  onUpdateQuery: (updates: Partial<SearchQuery>) => void
  onClearAll: () => void
}

export const FilterSheet = ({ open, onClose, query, categoryOptions, facets, filterCount, resultCount, onUpdateQuery, onClearAll }: FilterSheetProps) => {
  const t = useTranslations("search")
  return (
    <Sheet
      open={open}
      onClose={onClose}
      solid
      handle
      inset="gut"
      title={t("filters")}
      footer={
        <div className="max-w-takeover mx-auto flex w-full gap-200">
          <Button variant="secondary" fullWidth disabled={filterCount === 0} onClick={onClearAll}>
            {t("sheet.clear")}
          </Button>
          <Button variant="primary" fullWidth onClick={() => onClose(false)}>
            {t("sheet.viewResults", { resultCount: resultCount?.toLocaleString("es-MX") ?? "" })}
          </Button>
        </div>
      }
    >
      <div className="max-w-takeover mx-auto w-full">
        <FilterPanel query={query} categoryOptions={categoryOptions} facets={facets} onUpdateQuery={onUpdateQuery} labelPlacement="outside" />
      </div>
    </Sheet>
  )
}
